"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shared = _interopRequireDefault(require("../_shared"));

var _default = {
  cssVars: "\n    :root {\n      ".concat(_shared["default"], "\n      --sans-serif: Helvetica Neue,Helvetica,Arial,sans-serif;\n      --serif: georgia, serif;\n      --code: consolas, monaco, monospace;\n      --black: #333333;\n      --near-black: #666666;\n      --navy: #001b44;\n      --outline-blue: #286fad;\n      --dark-blue: #031f73;\n      --pacific-blue: #0093d6;\n      --blue: #3e7697;\n      --light-blue: #3455db;\n      --lightest-blue: #d4e4f5;\n      --alice-blue: #eafaff;\n      --washed-blue: #e9f1fa;\n      --dark-red: #e7040f;\n      --red: #ed1c24;\n      --light-red: #ff725c;\n      --orange: #f96302;\n      --dark-orange: #cb4814;\n      --light-orange: #fed4B9;\n      --green: #73b93b;\n      --dark-green: #1c8150;\n      --light-green: #9eebcf;\n      --gold: #ffb700;\n      --yellow: #fcc300;\n      --light-yellow: #fef5d7;\n      --dark-gray: #999999;\n      --gray: #c1c7c9;\n      --mid-gray: #eee;\n      --light-gray: #f8f8f8;\n      --near-white: #f5f5f5;\n      --white: #ffffff;\n    }\n  "),
  name: 'Thd.ca',
  backgroundColor: 'bg-white',
  accordion: {
    accordion: '',
    animateContentDisplay: true,
    item: {
      content: 'pa3 near-black',
      title: {
        base: {
          heading: {
            wrapper: 'f3',
            text: 'bb b--orange bw1 pb1'
          },
          normal: {
            wrapper: 'f4 bb b--mid-gray hover-bg-light-gray',
            text: ''
          }
        },
        collapsed: 'bg-white',
        expanded: '',
        collapsedAlternate: 'bg-white',
        expandedAlternate: '',
        padding: 'pa3',
        color: 'black',
        lastItemClosedStyle: 'bn',
        toggle: {
          color: 'orange',
          icon: 'MdClose',
          position: 'right',
          css: {
            collapsed: "\n              transform: rotate(-45deg);\n              color: var(--orange);\n            ",
            expanded: "\n              transform: rotate(0);\n              color: var(--black);\n            "
          }
        }
      }
    }
  },
  alert: {
    base: 'items-start',
    icons: {
      error: {
        color: 'red',
        vector: 'ExclamationBox'
      },
      primary: {
        color: 'near-black'
      },
      secondary: {
        color: 'near-black'
      },
      success: {
        color: 'green',
        vector: 'MdCheckCircle'
      },
      warning: {
        color: 'near-black',
        vector: 'ExclamationTriangle'
      }
    },
    spacing: 'mb3',
    types: {
      error: 'near-black b--red bg-light-red',
      primary: 'near-black b--pacific-blue bg-alice-blue',
      secondary: 'near-black b--gray bg-light-gray',
      success: 'near-black b--green bg-light-green',
      warning: 'near-black b--yellow bg-light-yellow'
    },
    typography: 'sans-serif f6 f5-ns'
  },
  avatar: {
    color: 'blue',
    size: '200px'
  },
  badges: ['bulk-price-elligible', 'guaranteed-to-fit', 'new-lower-price', 'over-stock', 'special-buy'],
  banner: {
    background: 'var(--white)',
    border: '1px solid var(--mid-gray)',
    heading: {
      fontWeight: '700',
      fontSize: '3rem',
      lineHeight: '4.25rem',
      paddingBottom: '10px'
    },
    subHeading: {
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '22px',
      paddingBottom: '25px'
    },
    anchor: {
      padding: '0 5px',
      textDecoration: 'underline',
      textDecorationLine: 'underline',
      color: 'var(--blue)'
    },
    imageBox: {
      borderColor: 'var(--mid-gray)',
      backgroundColor: 'var(--light-gray)'
    },
    imageBoxDragAccept: {
      borderColor: 'var(--green)'
    },
    imageBoxDragReject: {
      borderColor: 'var(--red)'
    },
    imageBoxFocused: {
      borderColor: 'var(--blue)'
    }
  },
  breadcrumbs: {
    delimiter: '>',
    svgDelimiter: 'data:image/svg+xml,%3Csvg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M2.55462 0.5L1.66663 1.44L4.55102 4.5L1.66663 7.56L2.55462 8.5L6.33329 4.5L2.55462 0.5Z" fill="%23666666"/%3E%3C/svg%3E',
    fontSize: 'f6',
    fontWeight: 700,
    linkColor: 'black',
    maxWidth: '1440px',
    isVisible: true
  },
  brightcoveplayer: 'lMczQWpmw',
  button: {
    base: 'bw1',
    hoverBackgroundColor: 'transparent',
    scaleOnHover: false,
    sizes: {
      normal: 'ph4 pv2 f5',
      small: 'ph3 pv2 f6'
    },
    disabled: {
      appearance: 'b--gray bg-gray',
      text: 'white',
      outline: {
        appearance: 'b--gray bg-transparent hover-bg-gray hover-white',
        text: 'gray'
      }
    },
    primary: {
      appearance: 'bg-orange b--white',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--orange hover-bg-orange hover-white',
        text: 'orange'
      },
      overrides: "\n        border-radius: .125rem;\n        &:hover {\n          background-color: var(--dark-orange);\n        }\n        &:focus {\n          background-color: var(--dark-orange);\n          outline: var(--outline-blue) auto 0.25rem;\n          outline-offset: 0.125rem;\n        }\n        &:active {\n          background-color: var(--dark-orange);\n          box-shadow: inset 0 1px 3px 0 rgb(0 0 0 / 50%);\n        }\n      "
    },
    secondary: {
      appearance: 'bg-white b--orange hover-bg-orange hover-white',
      text: 'orange',
      outline: {
        appearance: 'bg-transparent b--orange',
        text: 'orange'
      },
      overrides: "\n        border-radius: .125rem;\n        &:hover {\n          background-color: var(--dark-orange);\n          border-color: var(--white);\n        }\n        &:focus {\n          background-color: var(--dark-orange);\n          outline: var(--outline-blue) auto 0.25rem;\n          outline-offset: 0.125rem;\n          border-color: var(--white);\n          color: var(--white);\n        }\n        &:active {\n          background-color: var(--dark-orange);\n          box-shadow: inset 0 1px 3px 0 rgb(0 0 0 / 50%);\n          border-color: var(--white);\n          color: var(--white);\n        }\n      "
    },
    tertiary: {
      appearance: 'bg-transparent b--transparent',
      text: 'blue underline',
      outline: {
        appearance: 'bg-transparent b--transparent',
        text: 'blue'
      }
    },
    alert: {
      appearance: 'bg-red b--red',
      text: 'white underline',
      outline: {
        appearance: 'bg-transparent b--red',
        text: 'red'
      }
    }
  },
  table: {
    headerCell: 'fw7',
    size: {
      normal: {
        cellSize: 'pa2',
        headerCellSize: 'pa2'
      },
      large: {
        cellSize: 'pa3',
        headerCellSize: 'pa3'
      }
    },
    type: {
      standard: {
        cell: {
          tachyons: '',
          css: "\n          &:nth-child(1) {\n            background-color: #F2F2F2;\n          }\n          "
        },
        row: {
          css: "\n          &:nth-child(1) {\n            border-top-width: 1px;\n            border-top-style: solid;\n          }\n          border-color: #CCCCCC;\n          border-bottom-width: 1px;\n          border-bottom-style: solid;\n          "
        },
        header: 'black',
        rowBgColor: 'bg-white'
      },
      stripes: {
        cell: {
          tachyons: 'bg-gray',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-light-gray'
      }
    },
    typography: 'sans-serif f6'
  },
  checkbox: {
    checkboxBorderColor: 'gray',
    checkboxBorderRadius: '0px',
    checkboxBorderWidth: '2px',
    checkboxColorChecked: 'orange',
    checkboxColorDisabled: 'mid-gray',
    checkboxColorHover: 'transparent',
    checkboxSize: '15px',
    checkmarkColor: 'white',
    checkmarkPosition: 'left: 5px; top: 0px; width: 4px; height: 9px;',
    textColorDisabled: 'gray',
    textLeftOffset: '1.5rem',
    textTopOffset: '1px'
  },
  configurator: {
    enablePayPal: false,
    showExternalPromoMessage: true,
    draftBanner: {
      logoName: 'thd-logo'
    },
    global: "\n      .configurator-container hr { display: none; }\n      footer.footer { display: none; }\n      & [data-content=\"gcc-pcp-option-Width\"] h3,\n      & [data-content=\"gcc-pcp-option-Height\"] h3 {\n        border: none;\n        margin-bottom: 0;\n        & span {\n          border: none;\n        }\n      }\n    ",
    choice: {
      border: '',
      maxWidth: 'mw4'
    },
    choiceContainer: {
      borderRadius: '4px 0px 4px 4px',
      boxShadow: '0 4px 9px 0 #ccc, 0 3px 10px 0 #ccc',
      borderWidth: '2px',
      display: 'none',
      justifyContent: 'space-between',
      padding: '0px',
      paddingLeft: '0px',
      paddingBottom: '0px',
      zoomImage: {
        tachyons: "left-0",
        css: ""
      }
    },
    option: {
      base: 'relative-ns bn ba-ns flex-shrink-0',
      dictionaryTermBackgroundColor: 'bg-white',
      dictionaryTermColor: 'dark-gray',
      dictionaryTermIconColor: 'dark-gray',
      dictionaryTermInfoIcon: 'near-black',
      image: '',
      selectedIcon: 'orange',
      selectedText: 'orange',
      selectedLabel: '',
      sizeGroup: 'flex-wrap flex-nowrap-ns',
      showDivider: true,
      title: {
        base: 'f3 fw5 pt3 pr3 mb3 ttc bb b--moon-gray',
        border: 'dib bb bw1 b--orange pb2'
      }
    },
    price: {
      addsPrice: 'black fw7',
      text: 'black',
      width: 'w-55',
      padding: 'pr4',
      alignment: 'right',
      showShipping: true
    },
    productInfo: {
      price: {
        dimensions: true
      }
    },
    promo: 'red',
    shipping: 'dn',
    size: {
      showHelpText: false
    },
    ctaLabelsAlignments: 'justify-end',
    summary: {
      background: 'bg-light-gray',
      border: 'none',
      choiceValue: 'black',
      floatingBar: {
        background: 'bg-navy',
        priceColor: 'white'
      },
      stickyTop: '1rem',
      tableType: 'standard'
    }
  },
  pip: {
    preview: {
      container: {
        maxWidth: 'max-width: 350px;'
      },
      samples: {
        tachyons: 'db '
      },
      selectedSwatch: 'display: inline-block; float: left; max-width: 50%',
      selectedSwatchTy: '',
      selectedSwatchInfo: 'pt3',
      styledInfo: 'mh3-l mb3-l bb b--gray',
      priceAndPromo: 'display: inline-block; float: right; max-width: 50%'
    },
    productSpecifications: {
      adobeDownloadDisabled: ['fr-CA']
    },
    productSummary: {
      howToGetIt: {
        variant: 'static',
        "static": {
          color: 'var(--near-black)'
        }
      },
      howToGetItBorder: {
        paddingBottom: 'var(--spacing-medium)',
        marginBottom: 'var(--spacing-medium)',
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderColor: 'var(--gray)'
      },
      dimensionDropdowns: {
        showLabelValues: true
      },
      productInstallationCtaViewDisable: true,
      buttonWithCtaHide: {
        display: 'none'
      }
    },
    productOptions: {
      showSampleOrderAlert: {
        display: 'none'
      },
      alwayShowSamplesOnProductPreview: true,
      swatch: {
        price: {
          tachyons: 'flex justify-center'
        },
        name: {
          tachyons: 'tc'
        }
      }
    },
    productOverview: {
      exchangeDays: 30,
      mustReturnProduct: true,
      exclusiveGuarantee: false
    },
    productGallery: {
      internetNumLabel: 'Special Order SKU #'
    }
  },
  contentBox: {
    appearance: 'bg-white br0',
    content: 'f6',
    title: 'f3 fw4',
    expandArrowColor: 'orange'
  },
  dropdown: {
    arrowColor: 'near-black',
    arrowPosition: '.75rem',
    arrowVector: 'arrow',
    arrowSize: 'width="14" height="8.75"',
    borderColor: 'b--near-black',
    borderErrorColor: 'b--red',
    borderWidth: '1px',
    borderBottomWidth: '1px',
    borderRadius: 'br1',
    disabledLabel: 'near-black',
    fontWeight: 400,
    label: 'sans-serif',
    color: 'var(--black)',
    overrides: "\n      & [class*=\"StyledSelectContainer\"] {\n        &:after {\n          bottom: 10px;\n        }\n        select:focus {\n          box-shadow: inset 0 0 0 2px var(--near-black);\n        }\n      }\n    "
  },
  formComponents: {
    fontSize: {
      input: '14px',
      label: '16px'
    },
    inputDropdownHeight: {
      normal: '40px',
      small: '36px'
    }
  },
  globalStyles: "\n    font-size: 16px !important;\n    & [class*=\"ModalWithHeader\"] [class*=\"MainImageWrapperBase\"] > div {\n      display: block !important;\n    }\n    & [class*=\"MyAccount__auth\"] {\n      & [class*=\"bttn\"] {\n        font-size: 18px;\n        font-weight: 700;\n      }\n    }\n    & [class=\"MyAccount__item\"] {\n      font-size: 14px;\n      font-weight: 700;\n    }\n    .gcc-app .gcc-app {\n      padding-top: 0;\n    }\n    & .MessageBarText {\n      font-size: 16px;\n      padding: .5rem 0;\n      text-align: center;\n    }\n    & .MainFlyout__detailsHeader {\n      font-size: 44px;\n    }\n    & #BVQAFooterID {\n      &:before, &:after {\n        content: \" \";\n        display: table;\n        clear: both;\n      }\n    }\n    & #BVRRSummaryContainer {\n      width: 310px;\n    }\n    & #BVRRRatingSummaryLinkWriteID a:hover {\n      text-decoration: underline;\n    }\n    & [class*=\"ModalWithHeader\"] {\n      z-index: 9002;\n      & [class*=\"styles__CloseCol-sc\"]:before {\n        font-size: 14px;\n        font-weight: 700;\n        padding-right: 0.5rem;\n        line-height: 1;\n      }\n      & .pip-components__Visualizer--image-main {\n        max-width: 770px;\n        max-height: 770px;\n      }\n      & [class*=\"MainImageWrapperBase-sc\"] > div {\n        margin-top: 0;\n        margin-bottom: auto;\n      }\n    }\n    & .BVRRRatingSummaryLinks {\n      padding-top: 3px;\n    }\n    & #deliveryStoreAndZip {\n      background: #fff;\n      & .MyStore__hours, .MyStore__label {\n        font-size: 14px;\n      }\n    }\n    & p[class*=\"ProductTitle\"] {\n      font-size: 18px !important;\n    }\n    & p[class^=\"Text\"], .DeliveryZipInline__button--block {\n      font-size: 14px;\n    }\n    & p[class*=\"ProductBrand\"] {\n      font-size: 16px;\n      &:before {\n        font-weight: normal;\n      }\n    }\n    & [class*=\"ThumbnailInner-sc\"] {\n      & > img {\n        width: 100%;\n      }\n      & [class*=\"PlayIcon\"] {\n        border-radius: 100%;\n        background: rgba(0,0,0,.5);\n        font-size: 20px;\n        text-align: center;\n        padding: .45rem;\n        color: #fff;\n        &:before {\n          content: '\u25BA';\n          padding-left: 3px;\n        }\n      }\n    }\n    & [class*=\"ThumbnailBase-sc\"] {\n      padding: 3px;\n      margin: 0;\n      border: none !important;\n      & > div {\n        border: 1px solid #eee;\n      }\n      & > img {\n        width: 100%;\n      }\n      &:hover {\n        border: none !important;\n        & [class*=\"PlayIcon\"] {\n          color: #f96302 !important;\n        }\n      }\n    }\n    & [class*=\"ThumbnailBase-selected\"] {\n      border: none !important;\n      & > div {\n        border: 1px solid #f96302;\n      }\n    }\n    & [class*=\"StyledInternalUserLink\"] {\n      color: #000 !important;\n      text-decoration: none !important;\n      font-size: 14px;\n    }\n    & #sticky-header {\n      & [class*=\"BrandModelWrapper\"] {\n        font-size: 14px;\n      }\n      & [class*=\"TitleInfo\"] {\n        padding-top: 0.25rem;\n        padding-bottom: 0;\n        font-size: 18px;\n      }\n    }\n    & body {\n      color: var(--black);\n      min-width: 100vw;\n      max-width: 100vw;\n      margin: 0;\n      background-color: var(--white) !important;\n      & main {\n        max-width: 100vw;\n      }\n      & .CenteredList {\n        overflow: auto;\n      }\n      & .MessageBar {\n        max-width: 100vw;\n        overflow-x: hidden;\n      }\n      & .Header3 {\n        max-width: 100vw;\n        font-size: 14px;\n        & .TaskLinks {\n          font-size: 11px;\n        }\n        & .SearchBox__cover:after {\n          font-size: 14px;\n        }\n        * .ShoppingLinks__item {\n          margin-bottom: 0;\n        }\n      }\n      & #myStoreMobile,\n      & .localization__select-this-store {\n        font-size: 1rem;\n      }\n      & #myStore-overlayWrapper {\n        font-size: .875rem;\n      }\n      & .footer {\n        max-width: 100vw;\n        overflow-x: hidden;\n        font-size: 14px;\n        & .list__item {\n          margin-bottom: 0;\n        }\n        & .footerEmailSignup__submit {\n          font-size: 16px;\n        }\n      }\n    }\n  ",
  heading: {
    primary: {
      container: '',
      text: 'fw4'
    },
    secondary: {
      container: '',
      text: ''
    },
    font: {
      tachyons: {
        h1: 'f1',
        h2: 'f2',
        h3: 'f3',
        h4: 'f4',
        h5: 'f5',
        h6: 'f6',
        h7: 'f7'
      },
      manual: {}
    }
  },
  internalUser: {
    showEmptyCartLink: false,
    addSpaceForInternalUserHeader: true,
    clearCookiesClientSide: true
  },
  leadGeneration: {
    getStarted: {
      accountIcon: {
        color: 'var(--white)',
        size: '3em'
      },
      checkIcon: {
        color: 'var(--green)',
        size: '2em'
      },
      clockIcon: {
        color: 'var(--white)',
        size: '2.25em'
      },
      phoneIcon: {
        color: 'var(--orange)',
        size: '1.75em'
      }
    },
    highlighted: 'fw7 tc w-100 orange',
    howItWorks: {
      list: {
        style: "\n          content: counter(index, decimal);\n          counter-increment: index;\n          background-color: var(--orange);\n          color: var(--white);\n          display: inline-block;\n          position: absolute;\n          height: 1.75em;\n          width: 1.75em;\n          text-align: center;\n          vertical-align: middle;\n          line-height: 1.75em;\n          border-radius: 5em;",
        vertical: "left: 0;",
        horizontal: "top: -2.5em;"
      }
    },
    verifyAddress: {
      style: 'w-100 bg-light-blue',
      locationIcon: {
        color: 'blue',
        size: '1.25em'
      }
    }
  },
  link: {
    types: {
      anchor: {
        "default": 'black underline',
        hover: 'underline'
      },
      'high-visibility': {
        "default": 'b black',
        hover: 'underline',
        icon: {
          code: 'MdChevronRight',
          color: 'orange',
          position: 'after'
        }
      },
      standard: {
        "default": 'no-underline',
        hover: 'underline',
        overrides: "\n          color: var(--outline-blue);\n          &:hover {\n            color: #153a5a;\n          }\n        "
      },
      remove: {
        "default": 'black no-underline b',
        hover: 'underline',
        icon: {
          code: 'MdClose',
          color: 'dark-red',
          position: 'before'
        }
      }
    }
  },
  modal: {
    settings: {
      footer: false
    },
    borderRadius: 'br0',
    boxShadowCss: '0px 0px 40px rgba(0, 0, 0, 0.5)',
    closeButton: 'black',
    content: {
      appearance: 'pb3 ph3',
      withTitle: 'pa3'
    },
    header: {
      appearance: 'pa2',
      withTitle: 'bb b--mid-gray'
    },
    overlayColorRgba: 'rgba(0,0,0,.8)',
    title: 'fw5 f5 h2-ns ml2 pr2'
  },
  newsletterSignUp: undefined,
  orangePay: {
    cssStylesOverrides: "\n      .flex-container {\n        padding: 0;\n      }\n    ",
    borderWidth: '1px',
    formPaddingBottom: '2rem',
    formPaddingTop: '2rem',
    formMarginBottom: '0px',
    titleVisibility: 'visible'
  },
  price: {
    color: 'black',
    currency: '$',
    displayOrder: {
      prefix: 2,
      price: 1,
      promo: 3,
      suffix: 5,
      promoDesc: 6,
      promoSavings: 4,
      stackable: 7,
      extraPriceInfo: 2
    },
    extraPriceInfo: 'f6',
    prefix: '',
    savingsColor: 'dark-green',
    strikethroughColor: 'gray',
    suffix: '',
    superscriptCents: false,
    superscriptCurrency: false,
    showCentsDelimiter: false,
    priceFontSizeSmall: 'f2',
    priceFontSizeExSmall: 'f4',
    promoMessageLongColor: 'near-black',
    showExternalPromo: true
  },
  quantity: {
    backgroundColor: 'bg-white',
    borderColor: 'b--gray',
    borderRadius: 'br0',
    borderWeight: '',
    componentType: 'quantity'
  },
  radioButton: {
    radioButtonBackgroundColor: 'white',
    radioButtonBackgroundColorChecked: 'orange',
    radioButtonBorderColor: 'gray',
    radioButtonBorderColorChecked: 'orange',
    radioButtonBorderWidth: '2px',
    radioButtonColorChecked: 'white',
    radioButtonColorDisabled: 'mid-gray',
    radioButtonColorHover: 'transparent',
    radioButtonSize: '18px',
    radioButtonColor: 'white',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '3px'
  },
  rightRailFlyout: {
    appearance: 'f4 dn db-ns',
    content: {
      callUs: {
        backgroundColor: 'orange',
        link: 'tel:8009212119',
        text: '877-293-0022'
      },
      emailUs: {
        backgroundColor: 'near-black',
        link: 'mailto:customblinds@homedepot.com',
        text: 'Email Us'
      }
    },
    enabled: true,
    squareWidth: 40
  },
  selectionBox: {
    choiceSelectionBox: true,
    imageSelectionBox: true,
    borderColor: 'gray',
    borderColorSelected: 'orange',
    borderRadius: 'br2',
    borderWidth: '',
    borderWidthSelected: 'bw2',
    checked: {
      base: 'w3 h3 white flex items-center justify-center absolute',
      container: 'w3 overflow-hidden',
      overrides: "\n        transform: rotate(45deg);\n        font-size: 0.8rem;\n        top: -2.5rem;\n        right: -2.5rem;\n        align-items: flex-end;\n        justify-content: center;\n        & svg {\n          padding-bottom: 0.2rem;\n          transform: rotate(-45deg);\n          & path {\n            stroke: #fff;\n            stroke-width: 3px;\n          }\n        }\n      "
    },
    overrides: {
      base: "\n        border-top-right-radius: 0;\n        transition: all 0.2s ease-in-out;\n      ",
      disabled: "\n        filter: saturate(0) opacity(.6);\n        background-image:\n          linear-gradient(to right, #ccc 50%, transparent 50%),\n          linear-gradient(to right, #ccc 50%, transparent 50%),\n          linear-gradient(to bottom, #ccc 50%, transparent 50%),\n          linear-gradient(to bottom, #ccc 50%, transparent 50%);\n        background-position: left top, left bottom, left top, right top;\n        background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n        background-size: 10px 1px, 10px 1px, 1px 10px, 1px 10px;\n      ",
      enabled: "\n        &:hover {\n          box-shadow: 0 4px 9px 0 #ccc, 0 3px 10px 0 #ccc;\n        }\n      "
    }
  },
  spinner: {
    color: 'orange'
  },
  tag: {
    borderRadius: '.25rem',
    primary: {
      appearance: 'b--gold bg-gold',
      text: 'near-black'
    },
    secondary: {
      appearance: 'b--light-gray bg-light-gray',
      text: 'near-black'
    }
  },
  textInput: {
    borderColor: 'b--dark-gray',
    borderColorFocus: 'b--gray',
    errorColor: 'red',
    borderRadius: 'br1',
    borderWidth: '1px',
    disabledBackground: 'mid-gray',
    disabledLabel: 'dark-gray sans-serif',
    label: 'near-black sans-serif',
    showErrorIcon: true,
    optional: 'near-black sans-serif'
  },
  textInputButton: {
    borderColor: 'b--mid-gray',
    borderRadius: undefined,
    borderWidth: '2px',
    fontSize: 'f6'
  },
  toggleSwitch: {
    checked: 'var(--green)',
    unchecked: 'var(--gray)'
  },
  visualizer: {
    _settings: {
      actionButtons: 'secondary'
    },
    buttonColor: 'primary',
    design: {
      fixedTopPosition: {
        large: '1rem',
        medium: '9rem',
        small: '9rem'
      },
      zoomOut: null
    }
  },
  culture: {
    includeCultureCodeInNetworkRequests: true
  }
};
exports["default"] = _default;